<div class="settings" [ngClass]="{ slideOut: slideOut }">
    <header>
        <p-icon name="settings" [color]="iconColor"></p-icon>
        <p class="p-headline-4 title-settings">{{ 'Layouts.Masthead.SETTINGS' | translate }}</p>
    </header>

    <div class="items">
        <p-nav-item
            *ngFor="let item of data"
            [item]="item"
            [routerState]="routeState$ | async"
            (itemClicked)="navigate(item.routePath)"
            [attr.automation-id]="item.label | translate | toAutomationId: { prefix: 'tab' }"
        ></p-nav-item>
    </div>
    <p-icon class="close" name="x" [color]="iconColor" (click)="close()" [attr.automation-id]="'CloseSettingsMenu'"></p-icon>
</div>
